module.exports = __webpack_public_path__ + "static/bradBackgroundCrop2-c63eed7264b8582007bacfec8a1345af.jpg";